import { useEffect, useRef } from "react";

export function usePoll(fn: () => void, ms: number, active: boolean): void {
  const saved = useRef(fn);
  useEffect(() => {
    saved.current = fn;
  }, [fn]);
  useEffect(() => {
    if (!active) return;
    const iv = setInterval(() => saved.current(), ms);
    return () => clearInterval(iv);
  }, [ms, active]);
}
